import React from "react";

export default function CookieNotice() {
  return null;
}

// import React, { Component } from 'react';
// import styled from 'styled-components';

// import WP from 'WP';
// import { cookie } from 'helpers';
// import moment from 'moment-timezone';

// class CookieNotice extends Component {

//     constructor() {
//         super();
//         this.state = {
//             denied: false,
//         }
//     }

//     _onAccept() {
//         let todaysDate = moment(new Date()).tz('Europe/Paris');
//         let nextYear = todaysDate.year() + 1;
//         let endDate = moment(new Date(nextYear + '-01-01')).tz('Europe/Paris');
//         let daysBetween = endDate.diff(todaysDate,'days');

//         if(daysBetween > 0 ) {
//             cookie.set('terms_accepted', 'true', daysBetween);
//         } else {
//             cookie.set('terms_accepted', 'true', 365);
//         }
//     }

//     render() {
//         if(cookie.get('terms_accepted') || this.state.denied || WP.options && !WP.options.cookie_enabled) return null;
//         return (
//             <Wrapper>
//                 <div className="cookie-notice-text">
//                     { WP.trans.weUseCookiesToImproveYourExperience || 'We use cookies to improve your experience' }
//                 </div>
//                 <div className="cookie-action-buttons">
//                     <a href="#" onClick={this._onAccept} className="accept-cookie button">{WP.trans.ok || 'Allow'}</a>
//                     <a href="#" onClick={ () => this.setState({ denied: true}) } className="deny-cookie cn-button button">{WP.trans.deny || 'Deny'}</a>
//                     <a href={WP.options.cookie_redirect_url || '#'} className="more-info cn-button button">{ WP.trans.policy || 'Policy'}</a>
//                 </div>
//             </Wrapper>
//         );
//     }
// }

// export default CookieNotice;

// const Wrapper = styled.div`
//     position: fixed;
//     left: 0;
//     bottom: 0;
//     width: 100%;
//     height: auto;
//     z-index: 999;
//     background: #F3F3F3;
//     color: #000;
//     display: flex;
//     flex-wrap: wrap;
//     flex-direction: row;
//     justify-content: center;

//     @media(max-width: 480px) {
//         bottom:0;
//         max-width: 100%;
//     }

//     .button {
//         border-radius: 999px;
//         display: inline-block;
//         text-align: center;
//         white-space: no-wrap;
//         padding: .3rem 1.2rem;
//         margin: 0 0 0 20px;

//         &:hover {
//             background-color: black;
//             color: white;
//             transition: color .2s ease-in-out;
//         }
//     }

//     .cookie-notice-text {
//         padding: 35px 10px 30px 0;
//     }

//     .cookie-action-buttons {
//         padding: 30px 10px 30px 0;

//         @media(max-width: 480px) {
//             padding: 0 10px 30px 0;
//         }
//     }
// `
